/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import TextField from 'material-ui/TextField';
import {FormControl,FormControlLabel,FormHelperText} from 'material-ui/Form';
import { MenuItem } from 'material-ui/Menu';
import { InputLabel } from 'material-ui/Input';
import Radio, { RadioGroup } from 'material-ui/Radio';
import Divider from 'material-ui/Divider';
import Typography from 'material-ui/Typography';
import {TextValidator,SelectValidator,ValidatorForm} from 'react-material-ui-form-validator';
import Grid from 'material-ui/Grid';

class DomainInfo extends React.Component {

  constructor(props) {
     super(props);

     if(props.fields){
       this.state = props.fields;
     } else {
       this.state = {goldlassoWillPurchase:"true",currentlyOwnDomain:"false",whoWillConfigure:""};
     }

     this.validateNow = this.validateNow.bind(this);
  }

  validateNow = ()  => {
    this.refs.domainform.submit();
  }

  //to setstate from all the fields
  handleChange =name=> event=> {
    this.setState({ [name]: event.target.value });
  }

  handleSubmit=() =>{
    if(this.state.whoWillConfigure!=null && this.state.whoWillConfigure!=""){
      this.props.onSubmit(this.state);
    } else {

    }
  }

  handleError=(errors) => {
    if(errors.length>0){
      document.getElementsByName(errors[0].props.name)[0].focus();
    }
  }

  render() {
    const chooseLabel = () => <InputLabel>Select any option</InputLabel>;

    return (
      <div >
        <Divider light />
        <Typography type="title" className="headline">Enter your Domain Information</Typography>
        <ValidatorForm ref="domainform" onSubmit={this.handleSubmit}
            onError={this.handleError} >
          <Grid container spacing={24}>
            <Grid item xs={12} sm={10} md={6} lg={4}>
              <FormHelperText>What domain would you like to use for this eLoop account?*</FormHelperText>
              <TextValidator  fullWidth
                name="domainName" value={this.state.domainName}
                validators={['required']}
                errorMessages={['Please enter your domain name']}
                placeholder="Enter Domain Name*" onChange={this.handleChange('domainName')} />
              <a target="_blank" href="http://www.register.com/">Check domain availability</a>
            </Grid>
            <Grid item xs={12} sm={10} md={6} lg={4}>
              <FormHelperText>Will Gold Lasso be purchasing this domain on your behalf?*</FormHelperText>
              <RadioGroup aria-label="goldlassoWillPurchase" name="goldlassoWillPurchase" style={{display:"initial"}}
                onChange={this.handleChange('goldlassoWillPurchase')} value={this.state.goldlassoWillPurchase}>
                <FormControlLabel value="false" control={<Radio className="v_middle"/>} label="Yes" style={{display:"inline-block",width:"100px"}} />
                <FormControlLabel value="true" control={<Radio className="v_middle"/>} label="No" style={{display:"inline-block",width:"100px"}} />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sm={10} md={6} lg={4}>
              <FormHelperText>
                Do you currently own the domain that you listed above?*
              </FormHelperText>
              <RadioGroup aria-label="currentlyOwnDomain" name="currentlyOwnDomain" style={{display:"initial"}}
                onChange={this.handleChange('currentlyOwnDomain')} value={this.state.currentlyOwnDomain}>
                <FormControlLabel value="false" control={<Radio className="v_middle"/>} label="Yes" style={{display:"inline-block",width:"100px"}} />
                <FormControlLabel value="true" control={<Radio className="v_middle"/>} label="No" style={{display:"inline-block",width:"100px"}} />
              </RadioGroup>
            </Grid>
            <Grid item xs={12} sm={10} md={6} lg={4}>
              <FormHelperText>
                Who will configure the DNS for this domain?*
              </FormHelperText>
              <SelectValidator name="whoWillConfigure" style={{width:"100%"}}
                value={this.state.whoWillConfigure} onChange={this.handleChange('whoWillConfigure')}
                validators={['required']} errorMessages={['Please choose who will configure']}
                formControl={FormControl} inputLabel={chooseLabel}>
                <MenuItem key="Gold Lasso" value="Gold Lasso">Gold Lasso</MenuItem>
                <MenuItem key="Client" value="Client">Client</MenuItem>
              </SelectValidator>
              <FormHelperText>(If you are not sure of the answer, please choose Gold Lasso)</FormHelperText>
            </Grid>
            <Grid item xs={12} sm={10} md={6} lg={4}>
              <TextField fullWidth multiline value={this.state.addnNotes} rows="3"
                label="Add Additional Notes" onChange={this.handleChange('addnNotes')} />
            </Grid>
          </Grid>
        </ValidatorForm>
        <br/>
      </div>
    );
  }
}

export default DomainInfo;



// WEBPACK FOOTER //
// ./src/components/domaininfo.js